export default {
  company: (state, payload) =>
    (state.company = Object.assign({}, { ...payload })),

  addId: (state, payload) =>
    (state.company = { ...state.company, id: payload.company.id }),

  SET_COMPANY: (state, payload) => {
    state.company = payload;
  },
};
